export enum PositionEndpoints {
    Positions = '/positions'
}